import { render, staticRenderFns } from "./ConnectReservationSystem.vue?vue&type=template&id=4e53e5a0"
import script from "./ConnectReservationSystem.vue?vue&type=script&lang=js"
export * from "./ConnectReservationSystem.vue?vue&type=script&lang=js"
import style0 from "./ConnectReservationSystem.vue?vue&type=style&index=0&id=4e53e5a0&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4e53e5a0')) {
      api.createRecord('4e53e5a0', component.options)
    } else {
      api.reload('4e53e5a0', component.options)
    }
    module.hot.accept("./ConnectReservationSystem.vue?vue&type=template&id=4e53e5a0", function () {
      api.rerender('4e53e5a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/pop-up/account/ConnectReservationSystem.vue"
export default component.exports